import { z } from 'zod'
import { normalizePhone } from '../utils/phone'

export const OpenRentalSchema = z.object({
  bikeId: z.string().uuid(),
  customerPhone: z
    .string()
    .min(10)
    .transform((v) => normalizePhone(v)),
  consentGiven: z.literal(true),
  documentVerified: z.boolean(),
  documentVerificationMethod: z.enum(['ocr', 'manual']).optional(),
  tariffId: z.string().uuid(),
  plannedReturnAt: z.string().datetime(),
})

export type OpenRentalDto = z.output<typeof OpenRentalSchema>

export const CloseRentalSchema = z.object({
  returnPointId: z.string().uuid().optional(),
  priceOverride: z.number().positive().optional(),
  priceOverrideReason: z.string().min(5).optional(),
})

export type CloseRentalDto = z.infer<typeof CloseRentalSchema>
